var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDdMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 22H8C7.20459 21.9992 6.44199 21.6829 5.87956 21.1204C5.31712 20.558 5.00079 19.7954 5 19V5C5.00079 4.20459 5.31712 3.44199 5.87956 2.87956C6.44199 2.31712 7.20459 2.00079 8 2H16C16.7954 2.00079 17.558 2.31712 18.1204 2.87956C18.6829 3.44199 18.9992 4.20459 19 5V19C18.9992 19.7954 18.6829 20.558 18.1204 21.1204C17.558 21.6829 16.7954 21.9992 16 22Z",
    fill: "#FFC6B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22H8C7.20435 22 6.44129 21.6839 5.87868 21.1213C5.31607 20.5587 5 19.7956 5 19V16H19V19C19 19.7956 18.6839 20.5587 18.1213 21.1213C17.5587 21.6839 16.7956 22 16 22Z",
    fill: "#FA896B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDdMobile);
export default __webpack_public_path__ + "static/media/icon-dd-mobile.f663ef81c79b964555549c4417c6560a.svg";
export { ForwardRef as ReactComponent };